import Service, { service } from '@ember/service';
import { OD_SELECTED_TILES_IDS } from 'lumen/utils/constants/overview-dashboard-constants';

const TOP_INSIGHTS_TILE_IDS = [
  OD_SELECTED_TILES_IDS.my_otb,
  OD_SELECTED_TILES_IDS.market_otb,
  OD_SELECTED_TILES_IDS.my_revenue,
  OD_SELECTED_TILES_IDS.my_adr,
  OD_SELECTED_TILES_IDS.stay_date_graph,
];

const MARKET_TRENDS_TILE_IDS = [
  OD_SELECTED_TILES_IDS.demand_level,
  OD_SELECTED_TILES_IDS.pricing_difference,
  OD_SELECTED_TILES_IDS.price_opportunity,
  OD_SELECTED_TILES_IDS.events,
];

const DISTRIBUTION_HEALTH_TILE_IDS = [
  OD_SELECTED_TILES_IDS.ranking,
  OD_SELECTED_TILES_IDS.my_parity,
];

// Contains all tiles within the Top insights section that have an editable threshold
const CONFIGURABLE_THRESHOLD_TOP_INSIGHTS_TILE_IDS = [
  OD_SELECTED_TILES_IDS.my_otb,
  OD_SELECTED_TILES_IDS.market_otb,
  OD_SELECTED_TILES_IDS.my_adr,
];

// Contains all tiles within the Market trends section that have an editable threshold
const CONFIGURABLE_THRESHOLD_MARKET_TRENDS_TILE_IDS = [
  OD_SELECTED_TILES_IDS.demand_level,
  OD_SELECTED_TILES_IDS.pricing_difference,
];

// triptease tile IDs
// const META_PERFORMANCE_TILE_IDS = [
//   OD_SELECTED_TILES_IDS.triptease_monthlybudget,
//   OD_SELECTED_TILES_IDS.triptease_bookingfee,
//   OD_SELECTED_TILES_IDS.triptease_revenueshare,
//   OD_SELECTED_TILES_IDS.triptease_roas,
//   OD_SELECTED_TILES_IDS.triptease_impressionshare
// ];

export default class OdAccessService extends Service {
  @service access;
  @service('hotel-and-market') hotelAndMarketService;
  @service myotbSs;

  get availableTiles() {
    let selectedTiles =
      this.hotelAndMarketService.hotel?.overviewSettings?.selected_tiles;

    if (this.access.hasShortTermRentalOnlyStrTab) {
      selectedTiles = selectedTiles?.filter(
        (tileId) => tileId !== OD_SELECTED_TILES_IDS.short_term_rental,
      );
    }

    return selectedTiles;
  }

  get hasAtLeastOneConfigurableMarketTrendsTile() {
    return this.availableTiles.some((tileId) =>
      CONFIGURABLE_THRESHOLD_MARKET_TRENDS_TILE_IDS.includes(tileId),
    );
  }

  get hasAtLeastOneConfigurableTopInsightsTile() {
    return this.availableTiles.some((tileId) =>
      CONFIGURABLE_THRESHOLD_TOP_INSIGHTS_TILE_IDS.includes(tileId),
    );
  }

  get hasAtLeastOneDistributionHealthTile() {
    return this.availableTiles.some((tileId) =>
      DISTRIBUTION_HEALTH_TILE_IDS.includes(tileId),
    );
  }

  get hasAtLeastOneMarketTrendsTile() {
    return this.availableTiles.some((tileId) =>
      MARKET_TRENDS_TILE_IDS.includes(tileId),
    );
  }

  // Can be used to hide content in the overview template if required
  get hasAtLeastOneTopInsightsTile() {
    return this.availableTiles.some((tileId) =>
      TOP_INSIGHTS_TILE_IDS.includes(tileId),
    );
  }

  get isMarketInsightFull() {
    return this.access.hasFeature('app.market_insight.full');
  }

  // We show main occupancy tile OTB SS entry point in case:
  // 1. The empty_placeholder FF is available and the user has not dismissed the empty state info banner
  // 2. The otb.data_validation FF is available
  get isOtbSelfServiceOccupancyEntryPointVisible() {
    return (
      (this.myotbSs.showOtbSelfServiceEntryPoints &&
        this.access.hasFeature('otb.empty_placeholder')) ||
      this.access.hasFeature('otb.data_validation')
    );
  }

  // We show Market OTB datapoints (in feed entry, chart tooltips) if:
  // Case 1: Market OTB is integrated
  // Case 2: OTB is not integrated but has market eligibility
  get showMarketOtbDatapoints() {
    return (
      this.isTileVisible(OD_SELECTED_TILES_IDS.market_otb) ||
      (this.access.hasFeature('otb.market_benchmark_eligible') &&
        (this.access.hasFeature('otb.empty_placeholder') ||
          this.access.hasFeature('otb.data_validation')))
    );
  }

  get showMyOtbDatapoints() {
    return (
      this.isTileVisible(OD_SELECTED_TILES_IDS.my_otb) ||
      this.access.hasFeature('otb.empty_placeholder') ||
      this.access.hasFeature('otb.data_validation')
    );
  }

  // available ED tiles are returned by the API
  isTileVisible(tileId) {
    return this.availableTiles.includes(tileId);
  }
}
